<template>
  <!-- Page Content -->
  <div class="h-100 d-flex flex-column">
    <div class="row f-row justify-content-center h-100">
      <div class="col col-12 text-center no_nav_height" style="width:100%">
        <!-- Chart 1 -->
        <div
          class="d-flex flex-column"
          style="width: 100%;"
          v-bind:class="{
            showHist: newShowHistory,
            hideHist: !newShowHistory,
          }"
        >
          <!-- Row: title -->
          <div class="row f-row">
            <div
              class="markets-chart-title no-bdr-top markets-chart-border col col-5 d-flex align-items-center"
              style="font-size: 1rem!important;"
            >
              Historical spot rates
            </div>
            <div
              class="markets-chart-title no-bdr-top markets-chart-border col col-7"
            >
              <slot name="spot"></slot>
            </div>
          </div>
          <div
            class="row f-row"
            id="valuationControls"
            style="vertical-align: middle!important;"
          >
            <div class="col col-5 f-row row-middle-titles">
              <div
                class="row f-row"
                style="vertical-align: middle!important; padding-left: 60px!important;"
              >
                <div
                  class="col col-12"
                  style="background: var(--background); border: 1px solid var(--lightbackground)"
                >
                  <table
                    class="table table-sm table-borderless table-data-controls"
                    style="width: 100%;"
                  >
                    <tbody>
                      <tr class="txt-label-primary-5">
                        <td class="txt-label-primary-5">
                          {{ datePrefix }}
                        </td>
                        <td class="txt-label-primary-5">
                          Close:
                        </td>
                        <td class="txt-label-primary-5">
                          Fwd {{ termDisplayed.toUpperCase() }}:
                        </td>
                        <td class="txt-label-primary-5">
                          Vol {{ termDisplayed.toUpperCase() }}:
                        </td>
                        <td class="txt-label-primary-5">
                          Ewma:
                        </td>
                        <td class="txt-label-primary-5">
                          RR {{ termDisplayed.toUpperCase() }}:
                        </td>
                      </tr>
                      <tr>
                        <td class="txt-label-primary">
                          <div
                            id="valuationDate"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td class="txt-label-primary">
                          <div
                            id="valuationClose"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td class="txt-label-primary">
                          <div
                            id="valuationFwdH"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td class="txt-label-primary">
                          <div
                            id="valuationVolH"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td class="txt-label-primary">
                          <div
                            id="valuationVolEWMA"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td class="txt-label-primary">
                          <div
                            id="valuationRRH"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col col-1"></div>
            <div
              class="col col-5 f-row row-middle-titles container-data-controls"
            >
              <div
                class="row f-row"
                style="background: var(--background); border: 1px solid var(--lightbackground)"
              >
                <table
                  class="table table-sm table-borderless table-data-controls"
                  style="width: 100%;"
                >
                  <tbody>
                    <tr class="txt-label-primary-5">
                      <td class="txt-label-primary-5">
                        Date:
                      </td>
                      <td class="txt-label-primary-5">
                        Forward:
                      </td>
                      <td class="txt-label-primary-5">
                        Atmf Volatility:
                      </td>
                      <td class="txt-label-primary-5">
                        25&Delta; Risk Reversal:
                      </td>
                    </tr>
                    <tr>
                      <td class="txt-label-primary">
                        <div
                          id="valuationDate2"
                          class="candle-hover-info text-center"
                        >
                          -
                        </div>
                      </td>
                      <td class="txt-label-primary">
                        <div
                          id="valuationFwd"
                          class="candle-hover-info text-center"
                        >
                          -
                        </div>
                      </td>
                      <td class="txt-label-primary">
                        <div
                          id="valuationATMFVol"
                          class="candle-hover-info text-center"
                        >
                          -
                        </div>
                      </td>
                      <td class="txt-label-primary">
                        <div
                          id="valuationRR"
                          class="candle-hover-info text-center"
                        >
                          -
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row f-row" style="vertical-align: middle!important;">
            <div
              class="col col-4 row-middle-titles text-center"
              style="padding-left: 60px!important; padding-top: 2px!important; height: 2rem!important;"
            >
              <div
                class="btn-group btn-group-toggle btn-block mr-2 table-data-controls"
                role="group"
              >
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('1M')"
                  v-bind:class="[pickedDate === '1M' ? 'active' : '']"
                >
                  1M
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('2M')"
                  v-bind:class="[pickedDate === '2M' ? 'active' : '']"
                >
                  2M
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('3M')"
                  v-bind:class="[pickedDate === '3M' ? 'active' : '']"
                >
                  3M
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('6M')"
                  v-bind:class="[pickedDate === '6M' ? 'active' : '']"
                >
                  6M
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('1Y')"
                  v-bind:class="[pickedDate === '1Y' ? 'active' : '']"
                >
                  1Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('2Y')"
                  v-bind:class="[pickedDate === '2Y' ? 'active' : '']"
                >
                  2Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('3Y')"
                  v-bind:class="[pickedDate === '3Y' ? 'active' : '']"
                >
                  3Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('5Y')"
                  v-bind:class="[pickedDate === '5Y' ? 'active' : '']"
                >
                  5Y
                </button>
              </div>
            </div>
            <div
              class="col col-1 align-middle h-100"
              style="height: 2rem!important;"
            >
              <table
                class="table table-sm table-borderless table-data-controls h-100"
                style="width: 100%;"
              >
                <tbody>
                  <tr class="txt-label-primary-5">
                    <td class="txt-label-primary-5 align-middle">
                      Term:
                    </td>
                    <td class="txt-label-primary align-middle">
                      <HoverMultiSelection
                        :btnWidth="'4rem'"
                        :options="
                          termToDisplay.map((item) => ({
                            label: item.toUpperCase(),
                            value: item,
                          }))
                        "
                        :selected="termDisplayed"
                        @eventOnChangeOption="
                          (opt) => onUserTermSelection(opt.value)
                        "
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col col-2" style="height: 2rem!important;"></div>
            <div
              class="col col-3 row-middle-titles text-center"
              style="height: 2rem!important;"
            >
              <div
                class="div-mid-align btn-toolbar"
                role="toolbar"
                aria-label="Toolbar with button groups"
              >
                <div
                  class="btn-group btn-group-toggle btn-block ml-2 mr-2"
                  role="group"
                >
                  <button
                    type="button"
                    class="btn btn-candle"
                    v-on:click="_pickedFwdDate('1M')"
                    v-bind:class="[pickedDateFwd === '1M' ? 'active' : '']"
                  >
                    1M
                  </button>
                  <button
                    type="button"
                    class="btn btn-candle"
                    v-on:click="_pickedFwdDate('2M')"
                    v-bind:class="[pickedDateFwd === '2M' ? 'active' : '']"
                  >
                    2M
                  </button>
                  <button
                    type="button"
                    class="btn btn-candle"
                    v-on:click="_pickedFwdDate('3M')"
                    v-bind:class="[pickedDateFwd === '3M' ? 'active' : '']"
                  >
                    3M
                  </button>
                  <button
                    type="button"
                    class="btn btn-candle"
                    v-on:click="_pickedFwdDate('6M')"
                    v-bind:class="[pickedDateFwd === '6M' ? 'active' : '']"
                  >
                    6M
                  </button>
                  <button
                    type="button"
                    class="btn btn-candle"
                    v-on:click="_pickedFwdDate('1Y')"
                    v-bind:class="[pickedDateFwd === '1Y' ? 'active' : '']"
                  >
                    1Y
                  </button>
                  <button
                    type="button"
                    class="btn btn-candle"
                    v-on:click="_pickedFwdDate('18M')"
                    v-bind:class="[pickedDateFwd === '18M' ? 'active' : '']"
                  >
                    18M
                  </button>
                  <button
                    type="button"
                    class="btn btn-candle"
                    v-on:click="_pickedFwdDate('2Y')"
                    v-bind:class="[pickedDateFwd === '2Y' ? 'active' : '']"
                  >
                    2Y
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Row: Chart -->
          <div class="row f-row h-100" style="position: relative">
            <!-- Row: legend -->
            <div class="row f-row container-legends-histo-fwd">
              <div class="col col-2 text-left">
                <table
                  class="table table-sm table-responsive table-borderless table-market-legend"
                  style="width: 100%; background: rgba(0,0,0,0)"
                >
                  <tbody>
                    <tr>
                      <td class="text-center">
                        <div class="triangle-topleft"></div>
                        <span class="inline-ul ml-1">Up / Down</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row f-row container-legends-fwd">
              <div class="col col-6 text-left">
                <table
                  class="table table-sm table-borderless table-market-legend"
                  style="background: rgba(0,0,0,0);width:auto"
                >
                  <tbody>
                    <tr>
                      <td class="text-left" style="width:110px;">
                        <i
                          class="fa fa-minus mr-1"
                          style="color:var(--expo); margin: 0 0 0 5px"
                        ></i>
                        Forwards
                      </td>
                      <td class="text-left" style="width:110px;">
                        <span class="inline-ul">Zoom:</span>
                        <button
                          style="width: 1.2rem; height: 1.2rem; margin: 0 2px 0 3px!important; padding-top: 1px;"
                          class="btn btn-strat-blue"
                          v-on:click="onUserZoom(1)"
                        >
                          <i class="fa fa-plus" style="font-size: 0.9rem"></i>
                        </button>
                        <button
                          style="width: 1.2rem; height: 1.2rem; margin: 0!important; padding-top: 1px;"
                          class="btn btn-strat-blue"
                          v-on:click="onUserZoom(-1)"
                        >
                          <i class="fa fa-minus" style="font-size: 0.9rem"></i>
                        </button>
                      </td>

                      <td>
                        <div
                          class="col col-auto txt-label-primary-2"
                          style="justify-content: flex-start!important;"
                        >
                          <label
                            class="ml-1"
                            v-bind:class="[
                              showVol ? 'btn-checkbox-active' : 'btn-checkbox',
                            ]"
                          >
                            <input type="checkbox" v-on:click="onUserShowVol" />
                            <span>
                              <span
                                class="inh"
                                style="width: 10px!important;"
                                v-if="showVol"
                              >
                                &#x2714;
                              </span>
                              <span
                                class="inh"
                                style="width: 10px!important;"
                                v-else
                                >&#x2022;</span
                              >
                              <span
                                style="padding-left: 5px;"
                                :style="{
                                  color: showVol
                                    ? 'var(--textative)'
                                    : 'var(--textinactive)',
                                }"
                                >Options</span
                              >
                            </span>
                          </label>
                        </div>
                      </td>

                      <td v-show="showVol">
                        <div
                          class="col col-auto txt-label-primary-2"
                          style="justify-content: flex-start!important;"
                        >
                          <label
                            class="ml-3"
                            v-bind:class="[
                              showScale
                                ? 'btn-checkbox-active'
                                : 'btn-checkbox',
                            ]"
                          >
                            <input
                              type="checkbox"
                              v-on:click="onUserShowScale"
                            />
                            <span>
                              <span
                                class="inh"
                                style="width: 10px!important;"
                                v-if="showScale"
                              >
                                &#x2714;
                              </span>
                              <span
                                class="inh"
                                style="width: 10px!important;"
                                v-else
                                >&#x2022;</span
                              >
                              <span
                                style="padding-left: 5px;"
                                :style="{
                                  color: showScale
                                    ? 'var(--textative)'
                                    : 'var(--textinactive)',
                                }"
                                >Scale</span
                              >
                            </span>
                          </label>
                        </div>
                      </td>
                      <!--<td class="text-left" style="width:40px;" v-show="showVol">-->
                      <!--  Scale:-->
                      <!--</td>-->
                      <!--<td-->
                      <!--  class="text-left align-middle"-->
                      <!--  style="width:20px;"-->
                      <!--  v-show="showVol"-->
                      <!--&gt;-->
                      <!--  <label-->
                      <!--    :for="'scale_button'"-->
                      <!--    class="toggle__button_g"-->
                      <!--    style="height: 100%"-->
                      <!--    :class="{ actives: showScale }"-->
                      <!--  >-->
                      <!--    <input-->
                      <!--      type="checkbox"-->
                      <!--      @click="onUserShowScale"-->
                      <!--      :id="'scale_button'"-->
                      <!--    />-->
                      <!--    <span class="toggle__switch_g"></span>-->
                      <!--  </label>-->
                      <!--</td>-->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              class="col col-12 text-center progress-div"
              style="top: 50%;"
              v-if="showLoading || showLoadingVal"
            >
              <QSLoading
                :isLoading="showLoading || showLoadingVal"
                :size="40"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              class="col col-12 text-center"
              v-else-if="chartData.length === 0"
              style="position: absolute; left: 0; top: 27.5%; z-index: 10000000;"
            >
              No Data Available
            </div>
            <div class="col col-5 h-100">
              <div
                class="d-flex flex-column h-100"
                id="upper_chart-div"
                style="width: 100%;"
              >
                <svg id="svg-upper_chart"></svg>
              </div>
            </div>
            <div class="col col-7 h-100">
              <div
                class="h-100 d-flex flex-column"
                id="fwd_Vol-div"
                style="width: 100%;"
              >
                <svg id="svg-fwd_Vol"></svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Chart 2 -->
        <div
          class="d-flex flex-column"
          style="width: 100%;"
          v-bind:class="{
            showHist2: newShowHistory,
            hideHist2: !newShowHistory,
          }"
        >
          <!-- Row: title -->
          <div class="row f-row">
            <div class="markets-chart-title markets-chart-border col col-4">
              {{ asset == "currency" ? "Swap points" : "Futures" }}
            </div>
            <div class="markets-chart-title markets-chart-border col col-4">
              ATMF volatility
            </div>

            <div
              class="markets-chart-title markets-chart-border col col-4 text-left d-flex"
            >
              <span class="mr-auto">
                25&Delta; risk reversal
              </span>
              <div
                class="sidebarHidden on-over-pointer"
                style="width: 60px!important; text-align: center"
              >
                <span @click="onUserHideShow"
                  >{{ !newShowHistory ? "OPEN" : "CLOSE" }}:
                </span>
                <button
                  @click="onUserHideShow"
                  class="btn mr-1"
                  style="width: 12px;"
                >
                  <i class="fa fa-expand" v-if="!newShowHistory"></i>
                  <i class="fa fa-compress" v-if="newShowHistory"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- Row: Legend -->
          <div class="row f-row" v-show="newShowHistory">
            <div
              class="col col-4 text-center align-content-center"
              v-for="(_, index) in [0, 1, 2]"
              :key="index"
            >
              <table
                class="table table-sm table-responsive table-borderless table-market-legend"
                style="padding: 0 0 0 60px; margin: 0"
              >
                <tbody>
                  <tr>
                    <td
                      class="text-center"
                      v-for="(name, idx) in index === 1
                        ? termToDisplay
                        : termToDisplay.slice(0, -1)"
                      :key="idx"
                    >
                      <i
                        class="fa fa-minus mr-1"
                        :style="{ color: colorSelectionLines[idx] }"
                      ></i>
                      {{ name.toUpperCase() }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Row: Chart -->
          <div class="row f-row h-100" v-show="newShowHistory">
            <div class="col col-4" style="height:100%; width:100%">
              <div
                class="h-100 d-flex flex-column"
                id="fwd-div"
                style="width: 100%;"
              >
                <svg id="svg-fwd"></svg>
              </div>
            </div>

            <div class="col col-4" style="height:100%; width:100%">
              <div
                class="h-100 d-flex flex-column"
                id="vol-div"
                style="width: 100%;"
              >
                <svg id="svg-vol"></svg>
              </div>
            </div>

            <div class="col col-4" style="height:100%; width:100%">
              <div
                class="h-100 d-flex flex-column"
                id="rr-div"
                style="width: 100%;"
              >
                <svg id="svg-rr"></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  colorExpo,
  colorSelection2,
  currencyAxisFormat,
  currencyFormat,
  dnCandles,
  formatPercent,
  grayLightBackground,
  prefixOptions,
  tDays,
  textactive,
  tFormat,
  titleTexts,
} from "@/_core/_helpers/_parametric_tools";
import { D3Chart } from "@/_core/charts/D3Chart";
import { Chart } from "@/_core/refactor/Chart";
import { D3HoverValuation } from "@/_core/charts/D3ChartHoverEffects";
import { D3HoverValuationFwd } from "@/_core/charts/D3ChartHoverEffects";
import {
  formatDate_YMD,
  lengthByDate,
  lengthByDateForward,
  timeParseNoNull2,
} from "@/_core/_helpers/_helpers";
import {
  callDeltaToStrike,
  putDeltaToStrike,
  qVolatility,
} from "@/_core/_helpers/_quadraticVolatility";
import { getValuationData } from "@/_core/data/api_calls/valuation_data/getValuationData";
import { getFWDVol } from "@/_core/data/api_calls/fwd_vol/getFWDVol";
import {
  select,
  format,
  timeFormat,
  min,
  max,
  interpolateGreys,
  scaleSequential,
} from "d3";
import { recalculateLine } from "@/_core/charts/D3ChartHoverHelpers.js";
import HoverMultiSelection from "@/components/buttons/HoverMultiSelection.vue";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "Pricing",
  components: { QSLoading, HoverMultiSelection },
  props: {
    asset: { required: false, type: String, default: "currency" },
    colorTheme: { required: true, type: Boolean, default: true },
    currencyNumber: { required: true },
    processData: { required: true },
    renderAll: { required: false },
    showHistory: { required: true },
    showLoadingAux: { required: false, type: Boolean, default: false },
    showLoadingChart: { required: false, type: Boolean, default: false },
    spot: { required: true },
    isUpdatedRoute: { required: false, type: Boolean, default: false },
  },
  data() {
    return {
      chartData: [],
      chartDataFwd: [],
      chartDataRaw: [],
      chartDataRR: [],
      chartDataVol: [],
      colorSelectionLines: [],
      currencyAxisFormat: currencyAxisFormat,
      currencyFormat: currencyFormat,
      currencyValInitDate: null,
      currencyValuationData: [],
      currencyValuationDataRaw: [],
      D3Chart: null,
      D3ChartFwd: null,
      D3ChartFwdAndVol: null,
      D3ChartRR: null,
      D3ChartVol: null,
      D3HoverValuation: null,
      D3HoverValuationFwd: null,
      dateFormat: "%d %b %y",
      dateFormatFwd: "%d %b %y",
      datePrefix: "Month:",
      expandLeft: false,
      expandRight: false,
      formatDate_YMD: formatDate_YMD,
      formatPercent: formatPercent,
      fwdKeys: [],
      hideLeft: false,
      hideRight: false,
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      interval: "day",
      intervalFwd: "day",
      logo: require("@/assets/images/symbol_blue.svg"),
      minMaxYAxis: [1000000, -1000000],
      minMaxYAxisFwd: [1000000, -1000000],
      minMaxYAxisRR: [1000000, -1000000],
      minMaxYAxisVol: [1000000, -1000000],
      newShowHistory: true,
      pickedDate: "2Y",
      pickedDateFwd: "6M",
      prefixOptions: prefixOptions,
      rrKeys: [],
      selectedDays: 130,
      selectedDaysFwd: 130,
      showLoading: false,
      showLoadingVal: false,
      showMain: true,
      showScale: true,
      showVol: true,
      svgNode: null,
      svgNodeFwd: null,
      svgNodeFwdAndVol: null,
      svgNodeRR: null,
      svgNodeVol: null,
      tDays: tDays,
      termDisplayed: "1m",
      termToDisplay: ["1m", "3m", "6m", "1y", "ewma"],
      termToDisplayRaw: ["1m", "3m", "6m", "1y", "ewma"],
      tFormat: tFormat,
      title: "MONTHLY",
      titleTexts: titleTexts,
      volKeys: [],
      chartBodyUpper: [],
    };
  },
  created() {
    this.showLoading = true;
    this.showLoadingVal = true;
    this.D3Chart = new Chart("upper_chart");
    this.D3ChartFwdAndVol = new D3Chart("fwd_Vol-div", "svg-fwd_Vol");
    this.D3ChartFwd = new D3Chart("fwd-div", "svg-fwd");
    this.D3ChartVol = new D3Chart("vol-div", "svg-vol");
    this.D3ChartRR = new D3Chart("rr-div", "svg-rr");
    this.D3HoverValuation = new D3HoverValuation();
    this.D3HoverValuationFwd = new D3HoverValuationFwd();

    // === API calls
    let dat = new Date();
    dat.setDate(dat.getDay() - 7);
    this.currencyValInitDate = dat;
  },
  mounted() {
    if (this.asset != "currency") {
      this.termDisplayed = "1m";
      this.termToDisplay = ["1m", "2m", "3m", "4m", "5m", "6m", "ewma"];
      this.termToDisplayRaw = ["1m", "2m", "3m", "4m", "5m", "6m", "ewma"];
    }

    this.setColorsAndLegends();
    this.newShowHistory = this.showHistory;
    if (this.spot !== null && this.spot !== undefined && this.spot !== 0) {
      this.getCurrencyData();
      this.getCurrencyValuationData();
    }

    let _this = this;
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  watch: {
    showLoadingSpot(val) {
      this.showLoading = val;
      this.showLoadingVal = val;
    },
    colorTheme() {
      this.setColorsAndLegends();
      this.callWidth();
    },
    renderAll() {
      this.callWidth();
    },
    showHistory(val) {
      this.newShowHistory = val;
    },
    spot() {
      const needsInitialLoad = this.chartDataRaw.length === 0;
      const isUpdateSpot = needsInitialLoad ? false : !this.isUpdatedRoute;
      this.getCurrencyData(isUpdateSpot);
      this.getCurrencyValuationData(isUpdateSpot);
    },
    showLoadingChart() {
      this.getCurrencyData();
      this.getCurrencyValuationData();
      if (this.chartDataRaw.length > 0) {
        this.dataPrep();
        this.setYAxisLimits();
        this.renderHistoricalChartMethod();
        this.renderFwdAndVolChartMethod();
        this.renderFwdChartMethod();
        this.renderVolChartMethod();
        this.renderRRChartMethod();
        this.renderHoverHistorical();
      }
    },
    showLoading() {
      if (this.showLoading) {
        this.eraseCharts();
      } else if (!this.showLoadingVal) {
        if (this.chartDataRaw.length > 0) {
          this.dataPrep();
          this.setYAxisLimits();
          this.renderHistoricalChartMethod();
          this.renderFwdAndVolChartMethod();
          this.renderFwdChartMethod();
          this.renderVolChartMethod();
          this.renderRRChartMethod();
          this.renderHoverHistorical();
        }
      }
    },
    showLoadingVal() {
      if (this.showLoadingVal) {
        this.eraseCharts();
      } else if (!this.showLoadingVal) {
        if (this.chartDataRaw.length > 0) {
          this.dataPrep();
          this.setYAxisLimits();
          this.renderHistoricalChartMethod();
          this.renderFwdAndVolChartMethod();
          this.renderFwdChartMethod();
          this.renderVolChartMethod();
          this.renderRRChartMethod();
          this.renderHoverHistorical();
        }
      }
    },
  },
  methods: {
    updateChartHistorical() {
      const lastData = this.chartData.at(-1);
      const lastDataFwd = this.currencyValuationData.at(-1);
      lastData.close = this.spot;
      select("#valuationClose").text(format(this.currencyFormat)(this.spot));
      select("#valuationDate").text(timeFormat(this.dateFormat)(lastData.date));
      select("#valuationOpen").text(format(this.currencyFormat)(lastData.open));
      select("#valuationHigh").text(format(this.currencyFormat)(lastData.high));
      select("#valuationLow").text(format(this.currencyFormat)(lastData.low));
      select("#valuationClose").text(
        format(this.currencyFormat)(lastData.close),
      );
      select("#valuationFwdH").text(
        format(this.currencyFormat)(lastData["fwd-" + this.termDisplayed]),
      );
      select("#valuationVolH").text(
        format(this.formatPercent)(lastData["vol-" + this.termDisplayed]),
      );
      select("#valuationVolEWMA").text(
        format(this.formatPercent)(lastData["vol-ewma"]),
      );
      select("#valuationRRH").text(
        format(this.formatPercent)(lastData["rr-" + this.termDisplayed]),
      );

      select("#valuationDate2").text(
        timeFormat(this.dateFormat)(lastDataFwd.date),
      );
      select("#valuationFwd").text(
        format(this.currencyFormat)(lastDataFwd.value),
      );
      select("#valuationATMFVol").text(
        format(this.formatPercent)(lastDataFwd.atmfvol),
      );
      select("#valuationEWMAVol").text(
        format(this.formatPercent)(lastDataFwd.atmfvol),
      );
      select("#valuationRR").text(format(this.formatPercent)(lastDataFwd.rr));
      this.D3Chart.createCandleZoom({
        yField: "close",
      });

      // update the domain
      this.svgNodeFwdAndVol.x.domain(
        this.currencyValuationData.map(function(d) {
          return d.date;
        }),
      );
      // update candles
      for (let zoomElement of this.D3Chart.zoomElements) {
        zoomElement.recalculate({
          data: this.chartData,
          upColor: colorExpo(this.colorTheme),
          dnColor: dnCandles(this.colorTheme),
          customName: "UPPER",
          opacityUp: 0.6,
          opacityDn: 0.6,
        });
      }
      recalculateLine({
        svg: this.svgNodeFwdAndVol,
        data: this.currencyValuationData,
        fieldName: "value",
        xt: this.svgNodeFwdAndVol.x,
        customName: "line",
      });
      this.D3HoverValuationFwd.hoverFct(
        this.svgNodeFwdAndVol,
        this.currencyValuationData,
        this.spot,
        "FWD",
        this.dateFormat,
        this.currencyFormat,
        this.formatPercent,
        textactive(this.colorTheme),
        grayLightBackground(this.colorTheme),
        this.showVol,
        this.chartData[this.chartData.length - 1].date,
        this.colorTheme,
      );
    },
    setColorsAndLegends() {
      this.colorSelectionLines = colorSelection2(this.colorTheme);
      let c = this.colorSelectionLines;
      let l = c.length - 1;
      let len = this.volKeys.length - 1;
      if (this.volKeys.length > 0) {
        let terms = [],
          colSel = [],
          index = 0;
        this.volKeys.forEach(function(d, idx) {
          index = idx === len ? l : l - idx - 3;
          terms.push(d.replace("vol-", ""));
          colSel.push(c[index]);
        });
        this.colorSelectionLines = colSel;
        this.termToDisplay = terms;
      } else {
        this.colorSelectionLines = [
          c[l - 2],
          c[l - 3],
          c[l - 4],
          c[l - 5],
          c[l - 6],
          c[l - 7],
          c[l],
        ];
        this.termToDisplay = this.termToDisplayRaw;
      }
    },
    eraseCharts() {
      select("#upper_chart-div")
        .select("svg > *")
        .remove();
      select("#fwd_Vol-div")
        .select("svg > *")
        .remove();
      select("#fwd-div")
        .select("svg > *")
        .remove();
      select("#vol-div")
        .select("svg > *")
        .remove();
      select("#rr-div")
        .select("svg > *")
        .remove();
    },
    // ==================== user interactions ====================
    onUserHideShow() {
      if (!this.newShowHistory) {
        this.showMain = false;
      }
      setTimeout(() => {
        this.renderHistoricalChartMethod();
        this.renderFwdAndVolChartMethod();
        this.renderHoverHistorical();
      }, 100);
      setTimeout(() => {
        this.newShowHistory = !this.newShowHistory;
      }, 150);
      setTimeout(() => {
        if (this.newShowHistory) {
          this.renderFwdChartMethod();
          this.renderVolChartMethod();
          this.renderRRChartMethod();
        }
      }, 200);
      setTimeout(() => {
        this.showMain = true;
      }, 300);
      setTimeout(() => {
        this.renderHistoricalChartMethod();
        this.renderFwdAndVolChartMethod();
        this.renderHoverHistorical();
      }, 400);
    },
    onUserTermSelection(term) {
      this.termDisplayed = term;
      this.renderHistoricalChartMethod();
      this.renderFwdChartMethod();
      this.renderVolChartMethod();
      this.renderRRChartMethod();
      this.renderHoverHistorical();
    },
    onUserShowVol() {
      this.showVol = !this.showVol;
      this.renderFwdAndVolChartMethod();
    },
    onUserShowScale() {
      this.showScale = !this.showScale;
      this.renderFwdAndVolChartMethod();
    },
    onUserZoom(val) {
      let delta = 0.1 * (this.minMaxYAxis[1] - this.minMaxYAxis[0]);
      if (val === 1) {
        this.minMaxYAxis = [
          this.minMaxYAxis[0] + delta,
          this.minMaxYAxis[1] - delta,
        ];
      } else {
        this.minMaxYAxis = [
          this.minMaxYAxis[0] - delta,
          this.minMaxYAxis[1] + delta,
        ];
      }
      this.renderHistoricalChartMethod();
      this.renderFwdAndVolChartMethod();
      this.renderHoverHistorical();
    },
    _pickedDate(paramInterval) {
      this.pickedDate = paramInterval;
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map((d) => d.date),
      );
      this.dateFormat = this.tFormat[this.interval];
      this.datePrefix = this.prefixOptions[this.interval];
      this.title = this.titleTexts[this.interval];
      this.dataPrep();
      this.setYAxisLimits();
      this.renderHistoricalChartMethod();
      this.renderFwdAndVolChartMethod();
      this.renderFwdChartMethod();
      this.renderVolChartMethod();
      this.renderRRChartMethod();
      this.renderHoverHistorical();
    },
    _pickedFwdDate(paramInterval) {
      this.pickedDateFwd = paramInterval;
      this.selectedDaysFwd = lengthByDateForward(
        this.pickedDateFwd,
        this.currencyValuationDataRaw.map((d) => d.date),
      );
      this.fwdDataPrep();
      this.setYAxisLimits();
      this.renderHistoricalChartMethod();
      this.renderFwdAndVolChartMethod();
      this.renderHoverHistorical();
    },
    // ==================== valuations ====================
    setYAxisLimits() {
      let vis = this;
      this.minMaxYAxis = this.processData.minMax(this.chartData, "high", "low");
      this.minMaxYAxis = this.processData.minMax(
        this.currencyValuationData,
        "value",
        "value",
        this.minMaxYAxis,
      );
      let diff = Math.max(
        vis.spot - vis.minMaxYAxis[0],
        vis.minMaxYAxis[1] - vis.spot,
      );
      this.minMaxYAxis = [this.spot - diff, this.spot + diff];
    },
    getKeys(keys, includes) {
      let auxKeys = keys.filter((d) => d.includes(includes));
      let newKeys = [];
      this.termToDisplay.forEach(function(d) {
        if (auxKeys.indexOf(includes + d) > -1) {
          newKeys.push(includes + d);
        }
      });
      return newKeys;
    },
    dataPrep() {
      this.chartData = this.processData.toSlice(
        this.chartDataRaw,
        this.selectedDays,
      );
      if (this.interval !== "day") {
        this.chartData = this.processData.ohlcNest(
          this.chartData,
          this.interval,
        );
      }
      let keys = Object.keys(this.chartDataRaw[0]);
      this.fwdKeys = this.getKeys(keys, "fwd-");
      this.volKeys = this.getKeys(keys, "vol-");
      this.rrKeys = this.getKeys(keys, "rr-");
      this.chartDataFwd = this.processData.dataPrepMultiLines(
        "Forward",
        "fwd-",
        this.fwdKeys,
        this.chartData,
        "date",
      );
      this.chartDataVol = this.processData.dataPrepMultiLines(
        "Volatility",
        "vol-",
        this.volKeys,
        this.chartData,
        "date",
      );
      this.chartDataRR = this.processData.dataPrepMultiLines(
        "Risk Reversal",
        "rr-",
        this.rrKeys,
        this.chartData,
        "date",
      );
      let vis = this;
      this.minMaxYAxisFwd = [
        min(vis.chartDataFwd.series, (d) => min(d.values)),
        max(vis.chartDataFwd.series, (d) => max(d.values)),
      ];
      this.minMaxYAxisVol = [
        min(vis.chartDataVol.series, (d) => min(d.values)),
        max(vis.chartDataVol.series, (d) => max(d.values)),
      ];
      this.minMaxYAxisRR = [
        min(vis.chartDataRR.series, (d) => min(d.values)),
        max(vis.chartDataRR.series, (d) => max(d.values)),
      ];
    },
    fwdDataPrep() {
      this.currencyValuationData = this.currencyValuationDataRaw.slice(
        0,
        this.selectedDaysFwd,
      );
    },
    renderHistoricalChartMethod() {
      if (
        !this.showLoading &&
        !this.showLoadingVal &&
        this.chartData.length > 0
      ) {
        let vis = this;
        // === set SVG canvas
        this.D3Chart.setSVG({
          top: { perc: 0.5, px: 5 },
          right: { perc: 0.5, px: 2 },
          bottom: { perc: 0.5, px: 35 },
          left: { perc: 0.5, px: 60 },
        });
        if (this.D3Chart.svg.height === 0 || this.D3Chart.svg.width === 0) {
          return;
        }
        // === set axis
        this.D3Chart.setAxis({
          xData: this.chartData,
          minMaxYAxis: this["minMaxYAxis"],
          xFormat: this["dateFormat"],
        });
        // ==== zoom setup
        this.D3Chart.enableXZoom("chartBodyUpper", "clipUpper");

        // Divider - Vertical Line
        const x1 =
          this["D3Chart"].svg.x(vis.chartData.at(-1).date) +
          this["D3Chart"].svg.x.bandwidth() +
          2;
        const y2 = this["D3Chart"].svg.height;

        this["D3Chart"]["dividerLine"] = this["D3Chart"].addLines({
          type: "lineGeneral",
          strokeColor: dnCandles(this.colorTheme),
          x1,
          x2: x1,
          y2,
          className: "",
          strokeOpacity: 0.6,
        });
        // add candles
        this["D3Chart"].addCandles({
          type: "candles",
          data: this.chartData,
          upColor: colorExpo(this.colorTheme),
          dnColor: dnCandles(this.colorTheme),
          customName: "UPPER",
          opacityUp: 0.6,
          opacityDn: 0.6,
        });
        this["svgNode"] = this["D3Chart"];
      }
    },
    renderFwdAndVolChartMethod() {
      if (
        !this.showLoading &&
        !this.showLoadingVal &&
        this.chartData.length > 0
      ) {
        let rightMargin = 60;
        if (this.showVol === true) {
          if (this.showScale === true) {
            rightMargin = 120;
          }
        }
        // === set SVG canvas
        this.svgNodeFwdAndVol = this.D3ChartFwdAndVol.setSVG(
          0.5,
          5,
          0.5,
          rightMargin,
          0.5,
          35,
          0.5,
          0,
          this.colorTheme,
          this.logo,
          "up",
          this.newShowHistory,
        );
        if (
          this.svgNodeFwdAndVol.height === 0 ||
          this.svgNodeFwdAndVol.width === 0
        ) {
          return;
        }
        // === set axis
        this.svgNodeFwdAndVol = this.D3ChartFwdAndVol.setAxis(
          this.svgNodeFwdAndVol,
          this.currencyValuationData,
          this.minMaxYAxis,
          this.dateFormatFwd,
          60,
          8,
          false,
          [],
          true,
          true,
          false,
          [],
          false,
        );
        let contours, grid, color, scale, ticks, legendMargin, minVol, maxVol;
        if (this.showVol === true) {
          let cont = this.D3ChartFwdAndVol.contourVols(
            this.svgNodeFwdAndVol,
            this.currencyValuationData,
            dnCandles(this.colorTheme),
            0.07,
            false,
            [],
            scaleSequential(interpolateGreys),
            0.5,
            this.colorTheme,
          );
          contours = cont[0];
          grid = cont[1];
          color = cont[2];
          scale = contours.map((d) => color(d.value));
          ticks = contours.map((d) => d.value);
          ticks.push(2 * ticks[ticks.length - 1] - ticks[ticks.length - 2]);
          legendMargin = {
            top:
              this.svgNodeFwdAndVol.margin.top * 1.5 +
              0.5 * this.svgNodeFwdAndVol.margin.bottom,
            bottom:
              this.svgNodeFwdAndVol.margin.bottom * 1.5 +
              0.5 * this.svgNodeFwdAndVol.margin.top,
            left: 0,
            right: 30,
          };
          minVol =
            min(grid, function(d) {
              return Number.isFinite(d) ? d : Infinity;
            }) - 0.001;
          maxVol =
            max(grid, function(d) {
              return Number.isFinite(d) ? d : -Infinity;
            }) + 0.001;
        }
        this.D3ChartFwdAndVol.line(
          this.svgNodeFwdAndVol,
          this.currencyValuationData,
          colorExpo(this.colorTheme),
          2,
        );
        // add the vertical color legend
        if (this.showVol === true && this.showScale === true) {
          this.D3ChartFwdAndVol.vColorLegend(
            this.svgNodeFwdAndVol,
            scale,
            ticks,
            legendMargin,
            [minVol, maxVol],
            50,
            0.32,
          );
        }
        // === custom hover effects and info
        this.D3HoverValuationFwd.hoverFct(
          this.svgNodeFwdAndVol,
          this.currencyValuationData,
          this.spot,
          "FWD",
          this.dateFormat,
          this.currencyFormat,
          this.formatPercent,
          textactive(this.colorTheme),
          grayLightBackground(this.colorTheme),
          this.showVol,
          this.chartData[this.chartData.length - 1].date,
          this.colorTheme,
        );
      }
    },
    renderHoverLower(svg, name) {
      // === custom hover effects and info
      this.D3HoverValuation.hoverFct(
        svg,
        this.chartData,
        name,
        this.dateFormat,
        this.currencyFormat,
        this.formatPercent,
        this.termDisplayed,
        textactive(this.colorTheme),
        grayLightBackground(this.colorTheme),
        this.svgNodeFwd,
        this.svgNodeVol,
        this.svgNodeRR,
        this.colorTheme,
      );
    },
    renderLowerCharts(D3Chart, xData, data, minMaxYAxis, colors, yFormat) {
      // === set SVG canvas
      let svg = D3Chart.setSVG(
        0.5,
        5,
        0.5,
        15,
        0.5,
        30,
        0.5,
        60,
        this.colorTheme,
        this.logo,
        "up",
        true,
      );
      if (svg.height === 0 || svg.width === 0) {
        return;
      }
      // === set axis
      D3Chart.setAxis(
        svg,
        xData,
        minMaxYAxis,
        this.dateFormat,
        60,
        8,
        false,
        [],
        true,
        true,
        true,
        yFormat,
      );
      // === lines
      D3Chart.multiLine(svg, data, colors, 2);
      return svg;
    },
    renderFwdChartMethod() {
      if (!this.newShowHistory) {
        this.svgNodeFwd = { height: 0, width: 0 };
        return;
      }
      if (
        !this.showLoading &&
        !this.showLoadingVal &&
        this.chartData.length > 0
      ) {
        this.setColorsAndLegends();
        this.svgNodeFwd = this.renderLowerCharts(
          this.D3ChartFwd,
          this.chartData,
          this.chartDataFwd,
          this.minMaxYAxisFwd,
          this.colorSelectionLines,
          format(this.currencyAxisFormat),
          "LL",
        );
      }
    },
    renderVolChartMethod() {
      if (!this.newShowHistory) {
        this.svgNodeVol = { height: 0, width: 0 };
        return;
      }
      if (
        !this.showLoading &&
        !this.showLoadingVal &&
        this.chartData.length > 0
      ) {
        this.svgNodeVol = this.renderLowerCharts(
          this.D3ChartVol,
          this.chartData,
          this.chartDataVol,
          this.minMaxYAxisVol,
          this.colorSelectionLines,
          this.formatPercent,
          "LM",
        );
      }
    },
    renderRRChartMethod() {
      if (!this.newShowHistory) {
        this.svgNodeRR = { height: 0, width: 0 };
        return;
      }
      if (
        !this.showLoading &&
        !this.showLoadingVal &&
        this.chartData.length > 0
      ) {
        this.svgNodeRR = this.renderLowerCharts(
          this.D3ChartRR,
          this.chartData,
          this.chartDataRR,
          this.minMaxYAxisRR,
          this.colorSelectionLines,
          this.formatPercent,
          "LR",
        );
      }
    },
    renderHoverHistorical() {
      if (
        !this.showLoading &&
        !this.showLoadingVal &&
        this.chartData.length > 0 &&
        this.svgNodeFwd !== undefined &&
        this.svgNodeVol !== undefined &&
        this.svgNodeRR !== undefined
      ) {
        if (
          !("height" in this.svgNodeFwd) ||
          !("width" in this.svgNodeFwd) ||
          !("height" in this.svgNodeVol) ||
          !("width" in this.svgNodeVol) ||
          !("height" in this.svgNodeRR) ||
          !("width" in this.svgNodeRR)
        ) {
          return;
        }
        // === custom hover effects and info
        if (this.newShowHistory) {
          this.renderHoverLower(this.svgNodeFwd, "LL");
          this.renderHoverLower(this.svgNodeVol, "LM");
          this.renderHoverLower(this.svgNodeRR, "LR");
        }
        this.D3HoverValuation.hoverFct(
          this.svgNode.svg,
          this.chartData,
          "UPPER",
          this.dateFormat,
          this.currencyFormat,
          this.formatPercent,
          this.termDisplayed,
          textactive(this.colorTheme),
          grayLightBackground(this.colorTheme),
          this.svgNodeFwd,
          this.svgNodeVol,
          this.svgNodeRR,
          this.colorTheme,
        );
      }
    },
    callWidth() {
      if (
        !this.showLoading &&
        !this.showLoadingVal &&
        this.chartData.length > 0
      ) {
        this.renderHistoricalChartMethod();
        this.renderFwdAndVolChartMethod();
        this.renderFwdChartMethod();
        this.renderVolChartMethod();
        this.renderRRChartMethod();
        this.renderHoverHistorical();
      }
    },
    // ============= APIs ===============
    async getCurrencyData(isUpdateSpot = false) {
      if (!isUpdateSpot) this.showLoading = true;
      let vis = this;
      let asset = this.asset;
      await getFWDVol(this, asset)
        .then((data) => {
          if (asset != "currency") {
            data = JSON.parse(JSON.stringify(data));
            data.forEach(function(d) {
              d.date = timeParseNoNull2(d.observation_date);
            });
            // this.showLoading = false;
          }
          this.chartDataRaw = this.processData.includeSpot(data, this.spot);
          this.selectedDays = lengthByDate(
            this.pickedDate,
            this.chartDataRaw.map((d) => d.date),
          );
          if (!isUpdateSpot) {
            this.dataPrep();
            this.showLoading = false;
            this.setYAxisLimits();
            this.renderHistoricalChartMethod();
            this.renderFwdAndVolChartMethod();
            this.renderFwdChartMethod();
            this.renderVolChartMethod();
            this.renderRRChartMethod();
            this.renderHoverHistorical();
          }
        })
        .catch(function(error) {
          vis.showLoading = false;
          console.error(error);
        });
    },
    async getCurrencyValuationData(isUpdateSpot = false) {
      let _this = this;
      let asset = this.asset;
      if (!isUpdateSpot) this.showLoadingVal = true;
      let vis = this;
      await getValuationData(this, asset)
        .then((data) => {
          if (_this.asset != "currency") {
            data = data.data;
          }
          data = JSON.parse(JSON.stringify(data));
          let today;
          data.forEach(function(d) {
            today = new Date();
            d.observation_date = timeParseNoNull2(d.observation_date);
            d.date = new Date(
              today.setDate(today.getDate() + d.days_to_expiration),
            );
            if (asset != "currency") {
              d.rf = d.r;
              d.value = d.fwd;
            } else {
              d.value = +vis.spot + d.fwd;
            }
            d.days = +d.days_to_expiration;
            d.atmfvol = qVolatility(d, d.value);
            const strikeCall = callDeltaToStrike(
              +vis.spot,
              d.days / 365,
              d.r,
              d.rf,
              d.atmfvol,
              0.25,
            );
            const strikePut = putDeltaToStrike(
              +vis.spot,
              d.days / 365,
              d.r,
              d.rf,
              d.atmfvol,
              0.25,
            );
            d.rr = qVolatility(d, strikeCall) - qVolatility(d, strikePut);
          });
          this.currencyValuationDataRaw = data;
          this.selectedDaysFwd = lengthByDateForward(
            this.pickedDateFwd,
            this.currencyValuationDataRaw.map((d) => d.date),
          );
          this.fwdDataPrep();
          if (this.chartDataRaw.length > 0 && !isUpdateSpot) {
            this.setYAxisLimits();
            this.renderFwdAndVolChartMethod();
            this.renderFwdChartMethod();
            this.renderVolChartMethod();
            this.renderRRChartMethod();
            this.renderHoverHistorical();
          }

          if (
            this.chartDataRaw.length > 0 &&
            this.chartData.length > 0 &&
            isUpdateSpot
          ) {
            this.updateChartHistorical();
          }
          this.showLoadingVal = false;
        })
        .catch(function(error) {
          vis.showLoadingVal = false;
          vis.currencyValuationData = [];
          console.error(error);
        });
    },
  },
};
</script>
<style scoped>
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "";
}
select.dropdown-form.dropdown-sm option {
  background: black;
}
.container-legends-fwd {
  position: absolute;
  left: calc(39.2% + 40px);
  top: 5px;
  z-index: 1000;
}
.container-legends-histo-fwd {
  position: absolute;
  left: 65px;
  top: 5px;
  z-index: 0;
}

@media (max-width: 1150px) {
  .table-data-controls tr td {
    font-size: 0.85rem !important;
    white-space: nowrap;
  }
}

@media (max-width: 1300px) {
  .container-data-controls {
    max-width: 50% !important;
    flex: 1;
  }
}

/* @media (min-width: 1440px) {
  .container-legends-fwd,
  .container-legends-histo-fwd {
    top: 120px;
  }
} */
</style>
